import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { AddBox } from "@material-ui/icons";
import { Box, Button } from "@material-ui/core";
import RbTable from "./RbTable";
import AddVowDialog from "./AddVowDialog";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const VowContainer = () => {
  const classes = useStyles();
  const [openAdd, setOpenAdd] = useState(false);

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box className={classes.actionsContainer}>
          <Box className={classes.buttonsContainer}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddBox />}
              onClick={() => setOpenAdd(true)}
              style={{ marginRight: 14, marginBlock: "10px" }}
            >
              اضافه کردن
            </Button>
          </Box>
        </Box>
        <RbTable />
      </CmtCardContent>
      <AddVowDialog open={openAdd} handleClose={() => setOpenAdd(false)} />
    </CmtCard>
  );
};

export default VowContainer;
